import request from './request'

/**
 * 获取轨迹列表
 * @param {string} bizType - 业务类型：PLAN/ORDER
 * @param {number} bizId - 业务ID
 */
export function getTraceList(bizType, bizId) {
  return request.get('/trace/list', {
    params: { bizType, bizId }
  })
}

/**
 * 创建手动轨迹
 * @param {object} data - 创建参数
 * @param {string} data.bizType - 业务类型：PLAN/ORDER
 * @param {number} data.bizId - 业务ID
 * @param {string} data.traceType - 轨迹类型：NOTE
 * @param {string} [data.title] - 标题
 * @param {string} [data.content] - 内容
 */
export function createTrace(data) {
  return request.post('/trace', data)
}

/**
 * 更新手动轨迹
 * @param {object} data - 更新参数
 * @param {number} data.id - 轨迹ID
 * @param {string} [data.title] - 标题
 * @param {string} [data.content] - 内容
 */
export function updateTrace(data) {
  return request.put('/trace', data)
}

/**
 * 删除手动轨迹
 * @param {number} id - 轨迹ID
 */
export function deleteTrace(id) {
  return request.delete(`/trace/${id}`)
}
